import { stepData } from "../demoData";
import type { QuestionnaireSubmitPayload, StepId } from "../types";

export type MarketAnalysisResult = {
  recommended: {
    marketTitle: string;
    frequencyTitle: string;
    durationTitle: string;
  };
  user: {
    riskTitle: string;
    returnTitle: string;
    interpretTitle: string;
    constraintsTitle: string;
  };
};

function titlesFor(step: StepId, ids: string[]) {
  const config = stepData[step];
  const byId = new Map(config.options.map((o) => [o.id, o.title] as const));
  return ids.map((id) => byId.get(id) ?? id);
}

function joinTitles(titles: string[], fallback: string) {
  const compact = titles.map((t) => t.trim()).filter(Boolean);
  return compact.length ? compact.join(", ") : fallback;
}

function pickDuration(riskIds: string[], returnIds: string[]) {
  const risk = riskIds[0] ?? "";
  const ret = returnIds[0] ?? "";

  if (risk.includes("risk_low")) return "12 months";
  if (risk.includes("risk_high")) return "3 months";
  if (ret.includes("ret_high")) return "3 months";
  return "6 months";
}

export async function market_analysis(
  payload: QuestionnaireSubmitPayload
): Promise<MarketAnalysisResult> {
  await new Promise((r) => setTimeout(r, 650));

  const riskTitles = titlesFor("risk", payload.answers.risk);
  const returnTitles = titlesFor("return", payload.answers.return);
  const interpretTitles = titlesFor("interpret", payload.answers.interpret);
  const constraintsTitles = titlesFor("constraints", payload.answers.constraints);

  const durationTitle = pickDuration(payload.answers.risk, payload.answers.return);

  return {
    recommended: {
      marketTitle: "US Stocks",
      frequencyTitle: "Daily",
      durationTitle,
    },
    user: {
      riskTitle: joinTitles(riskTitles, "—"),
      returnTitle: joinTitles(returnTitles, "—"),
      interpretTitle: joinTitles(interpretTitles, "—"),
      constraintsTitle: joinTitles(constraintsTitles, "None"),
    },
  };
}
